import { apiClient } from './client';

/**
 * 결재함 API — backend `modules/approval/approval-box.routes.ts` (2026-09-07 · 시안 A1).
 *
 * ★★★ **전사결재함은 「결재양식」 팝업의 왼쪽 묶음이다.** 고르는 칸이 아니라, 양식을 고르는
 *    순간 그 양식이 속한 묶음이 그대로 문서의 함이 된다.
 * ★★ **표가 비어 있는 것이 정상이다** — 일곱은 서버 코드의 카탈로그가 갖고, 회사가 손댄 것만
 *    행이 된다. 그래서 `id` 가 `null` 인 줄이 섞여 온다.
 * ★ 옛 서버에는 이 라우트가 없다(404) — 부르는 쪽이 실패를 삼키고 빈 목록으로 돈다.
 */

export interface ApprovalBoxDto {
  /** `null` 이면 **아직 행이 없는 카탈로그 함**이다. 고치는 것은 `code` 로 한다. */
  id: string | null;
  code: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
  /** 씨앗인가, 회사가 만든 것인가. **파생이다** — 표에 칸이 없다. */
  origin: 'COMMON' | 'COMPANY';
}

/**
 * 부서 결재함 — **회사가 «열어야» 생긴다.**
 *
 * ★★★ 빈 배열이 정상이고, 그때 팝업의 그 칸은 「미지정」이다.
 *    기안자 소속으로 대신 채우지 않는다 — 아무것도 안 정했는데 정해진 값처럼 보인다.
 */
export interface ApprovalDeptBoxDto {
  id: string;
  /** 이 레포의 부서는 두 층이다 — 본부(`DIVISION`) 또는 팀(`TEAM`). */
  orgKind: 'DIVISION' | 'TEAM';
  orgId: string;
  name: string;
  isActive: boolean;
}

export async function listApprovalBoxes(): Promise<ApprovalBoxDto[]> {
  const { data } = await apiClient.get<{ items: ApprovalBoxDto[] }>('/approval/boxes');
  return Array.isArray(data?.items) ? data.items : [];
}

export async function createApprovalBox(
  input: { code: string; name: string; sortOrder?: number },
): Promise<ApprovalBoxDto> {
  const { data } = await apiClient.post<{ box: ApprovalBoxDto }>('/approval/boxes', input);
  return data.box;
}

/** 코드로 고친다 — 카탈로그 함은 «행이 없는» 상태로도 존재해서 id 를 못 쓴다. */
export async function updateApprovalBox(
  code: string,
  patch: { name?: string; sortOrder?: number; isActive?: boolean },
): Promise<ApprovalBoxDto> {
  const { data } = await apiClient.patch<{ box: ApprovalBoxDto }>(`/approval/boxes/${code}`, patch);
  return data.box;
}

export async function listApprovalDeptBoxes(): Promise<ApprovalDeptBoxDto[]> {
  const { data } = await apiClient.get<{ items: ApprovalDeptBoxDto[] }>('/approval/dept-boxes');
  return Array.isArray(data?.items) ? data.items : [];
}
